import { render } from "./BlockEdit.vue?vue&type=template&id=42c26289"
import script from "./BlockEdit.vue?vue&type=script&lang=js"
export * from "./BlockEdit.vue?vue&type=script&lang=js"
script.render = render

export default script